import { forwardRef } from 'react';
import { IconButton } from '@chakra-ui/react';

/** @typedef {import('@chakra-ui/react').IconButtonProps} IconButtonProps */
/** @typedef {import('react').RefAttributes<HTMLButtonElement>} ButtonRefAttributes */
/** @type {import('react').ForwardRefExoticComponent<IconButtonProps & ButtonRefAttributes>} */
const VIconButton = forwardRef(({ children, 'aria-label': ariaLabel, ...props }, ref) => (
  <IconButton ref={ref} aria-label={ariaLabel ?? 'icon button'} {...props}>
    {children}
  </IconButton>
));

VIconButton.displayName = 'VIconButton';

export default VIconButton;
